import React from 'react'
import { connect } from 'react-redux'
import CouponPresetActions from '../../Redux/CouponPresetRedux'
import Select from 'react-select'

class CreatePreset extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedProvider: null,
      form: {
        provider_id: '',
        card_type: '',
        prefix: ''
      }
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _selectChange = (selectedProvider) => {
    let form = { ...this.state.form }
    form.provider_id = selectedProvider.value
    this.setState({
      selectedProvider,
      form
    })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.form }
    this.props.postCouponPreset(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { couponProvider } = this.props

    // populate provider selector
    let providerPicker = []
    couponProvider.data.map((item, i) => (
      providerPicker[i] = {
        value: item.id,
        label: item.name
      }
    ))

    return (
      <section className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title'>Create Preset</h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Coupon Provider</label>
            </div>
            <div className='col-9'>
              <Select
                options={providerPicker}
                value={this.state.selectedProvider}
                onChange={(selectedProvider) => this._selectChange(selectedProvider)}
                required
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Card Type</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                placeholder=''
                className='form-control'
                value={this.state.form.card_type}
                required
                onChange={(event) => this._inputChange(event, 'card_type')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Prefix</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                placeholder=''
                className='form-control'
                value={this.state.form.prefix}
                required
                onChange={(event) => this._inputChange(event, 'prefix')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button className='btn btn-secondary mr-2' type='button' onClick={() => this.props.closeModal()}>Cancel</button>
              <button className='btn btn-primary' type='submit'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  couponProvider: state.couponProvider
})

const dispatchToProps = (dispatch) => ({
  postCouponPreset: (data) => dispatch(CouponPresetActions.postCouponPresetRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreatePreset)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/CreatePreset.js